import { useProfileStore } from '@/store/profile.module'
import { computed } from 'vue'

export function useStripeBillingEnabled() {
  const profileStore = useProfileStore()
  const companyId = computed(() => profileStore.selectedCompany?.id)

  const stripeBillingEnabled = computed(() => {
    if (!companyId.value) {
      return false
    }
    return profileStore.isStripeBillingEnabled(companyId.value)
  })

  return {
    companyId,
    stripeBillingEnabled
  }
}
